import React, {useEffect} from 'react'
import {Helmet} from "react-helmet";

const StepFour = ({packData}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    // get color percentage (on a 0-90 scale cause 100 makes too much sense)
    const colorPercent = parseInt(packData.color) * 100 / 90
    const colorStyle = {
        left: `${colorPercent}%`
    }

    // get viscosity percentage (range is 15.0 to 18.6)
    const viscBase = parseInt(packData.viscosity) - 15
    const viscPercent = 100 - viscBase * 100 / 3.6
    const viscStyle = {
        left: `${viscPercent}%`
    }
    const viscMeterStyle = {
        width: `${viscPercent}%`
    }

    // get tendency to crystalize number (range 1-10 :))
    const crystalPercent = parseInt(packData.crystalization) * 10
    const crystalStyle = {
        left: `${crystalPercent}%`
    }
    const crystalMeterStyle = {
        width: `${crystalPercent}%`
    }


    return (
        <div className="contain step step-four">
        <Helmet>
            <meta charSet="utf-8" />
            <title>Honey Characteristics || Busy Bee Honey</title>
        </Helmet>
            <h1>The unique characteristics of this busy bee honey:</h1>
            <div className="meter-section">
                <h3>Flavor</h3>
                <div className="flavor-meter">
                    <span className={`flavor-meter-item ${(packData.flavorClass === "Distinct") ? "selected" : "" }`}>
                        DISTINCT
                    </span>
                    <span className={`flavor-meter-item ${(packData.flavorClass === "Mild") ? "selected" : "" }`}>
                        MILD
                    </span>
                    <span className={`flavor-meter-item ${(packData.flavorClass === "Moderate") ? "selected" : "" }`}>
                        MODERATE
                    </span>
                    <span className={`flavor-meter-item ${(packData.flavorClass === "Robust") ? "selected" : "" }`}>
                        ROBUST
                    </span>
                </div>
                <p className="sub-desc">Many factors will influence your honey’s flavor, which can range from mild to more robust — or a more distinct taste unique to certain floral sources.</p>
            </div>
            <div className="meter-section">
                <h3>Color</h3>
                <div className="meter color-meter">
                    <span className="meter-gauge" style={colorStyle}></span>
                    <span className="color-bar color-bar-1"></span>
                    <span className="color-bar color-bar-2"></span>
                    <span className="color-bar color-bar-3"></span>
                </div>
                <div className="meter-key">
                    <span>LIGHT</span>
                    <span>MEDIUM</span>
                    <span>DARK</span>
                </div>
                <p className="sub-desc">Your honey's color varies based on the types of floral sources the bees used.</p>
            </div>
            <div className="meter-section">
                <h3>Viscosity</h3>
                <div className="meter color-meter">
                    <span className="meter-fill" style={viscMeterStyle}></span>
                    <span className="meter-gauge" style={viscStyle}></span>
                </div>
                <div className="meter-key">
                    <span>LESS VISCOUS</span>
                    <span>MORE VISCOUS</span>
                </div>
                <p className="sub-desc">The viscosity, or the thickness, of the honey varies by floral source and environmental conditions. Less viscous honey has more moisture content and is thinner than a more viscous, thicker honey.</p>
            </div>
            <div className="meter-section">
                <h3>Tendency to Crystallize</h3>
                <div className="meter color-meter">
                    <span className="meter-fill" style={crystalMeterStyle}></span>
                    <span className="meter-gauge" style={crystalStyle}></span>
                </div>
                <div className="meter-key">
                    <span>LESS LIKELY</span>
                    <span>MORE LIKELY</span>
                </div>
                <p className="sub-desc">While crystallization is a natural process affecting nearly all honey, raw honey is more prone to crystallization. If honey crystallizes or hardens, place the container in warm water until it returns to its original form.</p>
            </div>
        </div>
    )
}

export default StepFour
